import {addLead} from '../../../../third-party/mailgun/services/mailgunService'

export const attemptAddLead = (lead) => {
    addLead(lead)
        .then(response => {
        })
        .catch(err => {
            console.log('attemptAddLead > err:', err);
            
        })
}




// WEBPACK FOOTER //
// ./src/platform/notifications/leads/services/leadService.js